import { c as _c } from "react/compiler-runtime";
import { getPaymentMethodIcon } from '@systemeio/ui/icons';
import { Checkbox, PaymentMethodEnum, getPaymentMethodTitle, useTranslation as useUiTranslation } from '@systemeio/ui';
import React, { useEffect } from 'react';
import { FieldErrorAndDescription, FieldErrorAndDescriptionProps } from 'shared/components/form/field-error-and-description';
import { FieldLabel } from 'shared/components/form/field-label';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface PaymentMethodsProps extends FieldErrorAndDescriptionProps {
  value?: PaymentMethodEnum[];
  onChange: (value?: PaymentMethodEnum[]) => void;
  data?: PaymentMethodEnum[];
  isPreFetching?: boolean;
  required?: boolean;
}
const PaymentMethods = t0 => {
  const $ = _c(29);
  const {
    value,
    onChange,
    data,
    isPreFetching,
    error,
    required
  } = t0;
  const {
    t: tUi
  } = useUiTranslation();
  let t1;
  if ($[0] !== data || $[1] !== onChange || $[2] !== value) {
    t1 = () => {
      if (value && data) {
        const validItems = value.filter(item => data.includes(item));
        if (validItems.length !== value.length) {
          onChange(validItems);
        }
      }
    };
    $[0] = data;
    $[1] = onChange;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== data || $[5] !== value) {
    t2 = [value, data];
    $[4] = data;
    $[5] = value;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  const {
    t
  } = useLocoTranslation();
  const t3 = `flex-col gap-1 ${data && data.length === 0 ? "hidden" : "flex"}`;
  let t4;
  if ($[7] !== t) {
    t4 = t("dashboard.payment_methods.allowed_payment_methods");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== required || $[10] !== t4) {
    t5 = <FieldLabel label={t4} required={required} />;
    $[9] = required;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== data || $[13] !== isPreFetching || $[14] !== onChange || $[15] !== tUi || $[16] !== value) {
    t6 = isPreFetching || !data || !value ? <PaymentMethodsSkeleton /> : data.map(el => {
      const isSelected = value.includes(el);
      return <li key={el}><Checkbox value={isSelected} label={<div className={`flex items-center gap-1.5 [&>svg]:h-[20px] [&>svg]:w-[20px] ${isSelected && "[&>svg]:fill-brand-primary [&>svg]:main-transition-colors"}`}>{getPaymentMethodIcon(el)}{getPaymentMethodTitle(el, tUi)}</div>} onChange={() => isSelected ? onChange(value.filter(method => method !== el)) : onChange([...value, el])} /></li>;
    });
    $[12] = data;
    $[13] = isPreFetching;
    $[14] = onChange;
    $[15] = tUi;
    $[16] = value;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t6) {
    t7 = <ul className="flex flex-row flex-wrap gap-5">{t6}</ul>;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t3 || $[21] !== t5 || $[22] !== t7) {
    t8 = <div className={t3}>{t5}{t7}</div>;
    $[20] = t3;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== error) {
    t9 = <FieldErrorAndDescription error={error} />;
    $[24] = error;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t8 || $[27] !== t9) {
    t10 = <div className="flex-col gap-1 text-sm font-medium">{t8}{t9}</div>;
    $[26] = t8;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
};
const PaymentMethodsSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex animate-pulse gap-7"><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div><div className="bg-skeleton-primary/40 h-[23px] rounded-lg px-7 text-transparent">.</div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default PaymentMethods;